module.exports = ".modal-full-width {\n  width: 98% !important;\n  padding: 0 !important;\n  margin: 1% auto !important;\n}\n"